import React from 'react'
import { LoadingSpinner } from '@paypalcorp/pp-react'

const SpinnerAdapter = (props) => (
  <LoadingSpinner align="center" theme="v2" size="xl" {...props} />
)

export default SpinnerAdapter
